import { ApolloProvider } from "@apollo/client";

import App from "../App";
import { client } from "../config/apollo";

const SetupApp = () => {
  return (
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  );
};

export default SetupApp;
